import { Navigate, useLocation } from 'react-router-dom';
import { captureReturnTo } from '@/auth/return-to';

/**
 * The unauthenticated-redirect guard (PROD-2366).
 *
 * Extracted out of `App.tsx` so the login round trip can be exercised end to
 * end in a test without mounting the whole authenticated shell (SideNav,
 * notifications, SignalR, lazy route chunks). The extraction is the point:
 * the previous one-line `<Navigate … state={{ from: location.pathname }} />`
 * inside App was untestable in isolation, which is how a guard that silently
 * threw away the query string survived this long.
 *
 * `captureReturnTo` keeps pathname + search + hash verbatim, so no parameter
 * has to be registered anywhere to survive a login.
 */
export function LoginRedirect() {
  const location = useLocation();
  return (
    <Navigate to="/login" replace state={{ from: captureReturnTo(location) }} />
  );
}
